/**
 * FORM
 */
// BunnyJS
// https://stackoverflow.com/questions/34747693/how-do-i-get-babel-6-to-compile-to-es5-javascript
// import {Validation} from 'bunnyjs/src/Validation';
const BunnyValidation = require('../../bunnyjs/Validation');
BunnyValidation.Validation.lang = {
  required: '!',
  email: '!',
  url: '!',
  tel: '!',
  maxLength: '!',
  minLength: '!',
  maxFileSize: '!',
  image: '!',
  minImageDimensions: '!',
  maxImageDimensions: '!',
  requiredFromList: '!',
  confirmation: '!',
  minOptions: '!'
};
// const BunnyForm = require('./bunnyjs/form/form');

import axios from 'axios'
import {
  TweenMax,
  Power0,
  Power2,
  TweenLite
} from 'gsap';

var Register = function() {
  var container = document.getElementById('game-form-container');
  var form = document.getElementById('game-form');
  var gender = form.querySelector('#civil');
  var status = form.querySelector('#form-status');
  var _onFormRegisterCompleteCbk;
  var _bForm2 = false;

  var _score = 0;

  function showForm(score) {
    _score = score
    emptyForm();
    // initForm();
    container.style.display = 'flex'
    TweenMax.to(container, 0.5, {delay: 1.3, autoAlpha: 1})
  }

  function hideForm() {
    // btClose.removeEventListener('click', closeForm);
    // document.getElementById('game-form-container').classList.remove('show');
    TweenMax.to(container, 0.5, {delay: 0, autoAlpha: 0})
  }

  function translateForm(lang) {
    console.log(`LANG`, lang);
    form.querySelector('.game-form-title').innerHTML = _bForm2 ? lang.title2 : lang.title;
    gender.querySelector('[value="m"]').innerHTML = lang.male;
    gender.querySelector('[value="f"]').innerHTML = lang.female;
    gender.querySelector('[value="u"]').innerHTML = lang.other;
    form.querySelector('.civil-label').innerHTML = lang.gender + '*';
    form.querySelector('.firstname-label').innerHTML = lang.name + '*';
    form.querySelector('.lastname-label').innerHTML = lang.lastname + '*';
    form.querySelector('.email-label').innerHTML = lang.email + '*';

    let _city = form.querySelector('.city-label');
    let _cityInput = form.querySelector('#city');
    console.log(`CITY`, lang.city);
    if (lang.city && _city) {
      _city.innerHTML = lang.city + '*';
    } else if (_city) {
      _city.parentNode.style.display = 'none';
      _cityInput.value = 'N/A';
      _cityInput.removeAttribute('required');
    }

    let _country = form.querySelector('.country-label');
    let _countryInput = form.querySelector('#country');
    if (lang.country && _country) {
      _country.innerHTML = lang.country + '*';
    } else if (_country) {
      _country.parentNode.style.display = 'none';
      _countryInput.value = window.country;
      _countryInput.removeAttribute('required');
    }

    let _question = form.querySelector('.question-label');
    let _questionInput = form.querySelector('#question');
    if (_question && (lang.question || lang.question2)) {
      form.querySelector('.question-label').innerHTML = _bForm2 ? lang.question2 + '*' : lang.question + '*';
    } else if(_question) {
      _question.parentNode.style.display = 'none';
      _questionInput.value = 0;
      _questionInput.removeAttribute('required');
    }
    // form.querySelector('.fragrance-yes-label').innerHTML = lang.yes;
    // form.querySelector('.fragrance-no-label').innerHTML = lang.no;
    form.querySelector('.rules').innerHTML = lang.rules;
    form.querySelector('.newsletter_shop').innerHTML = lang.newsletter_shop;
    form.querySelector('.newsletter_jpg').innerHTML = lang.newsletter_jpg;
    form.querySelector('.required-txt').innerHTML = lang.required;
    // form.querySelector('#form1_skip').setAttribute('value', lang.skip);

    let _legal = form.querySelector('.question-label');
    if (_legal && lang.legal) {
      form.querySelector('.legal-label').innerHTML = lang.legal;
    } else if(_legal) {
      _legal.style.display = 'none';
    }

    if (window._sfPOS) {
      form.querySelector('.game-form-kit-description').innerHTML = lang.kit;
    }

    var elCountry = form.querySelector('#country');
    var elOption;
    // Populate countries
    if (lang.countries_and_code !== undefined) {
      for(var i=0, nb = lang.countries_and_code.length; i < nb; ++i) {
        elOption = document.createElement('option');
        elOption.setAttribute('value', lang.countries_and_code[i].iso);
        elOption.innerHTML = lang.countries_and_code[i].c;
        elCountry.appendChild(elOption);
      }
    } else {
      for(var i=0, nb = lang.countries.length; i < nb; ++i) {
        elOption = document.createElement('option');
        elOption.setAttribute('value', lang.countries[i]);
        elOption.innerHTML = lang.countries[i];
        elCountry.appendChild(elOption);
      }
    }
  }

  // Empty the Form
  function emptyForm() {
    form.firstname.value = '';
    form.lastname.value = '';
    form.email.value = '';
    form.civil.value = '';
    form.country.value = '';
    // form.elements.fragrance.checked = false;
    // form.elements.mode.checked = false;
  }

  function initForm(bForm2, onFormRegisterCompleteCbk) {
    console.log(`INIT FORM ${window.lang}`);

    // BunnyForm.Form.init('game-form');
    // BunnyValidation.Validation.init(document.getElementById('game-form'), true); // init can't be used, it has an automatic form.submit()
    _bForm2 = bForm2;
    _onFormRegisterCompleteCbk = onFormRegisterCompleteCbk;
    axios.get('lang/lang.json')
      .then((response)=>{
        console.log(`JSON LANG loaded`, response);
        let _lang = response.data[window.country]
        if (_lang) {
          _lang = _lang.register
          console.log(`lang ${window.country}`, _lang);
          _initForm(_lang);
        }
      })
      .catch((error)=>{
        console.error(`Error loading json`, error)
      })
  }

  function showFormSuccessMessage() {
    TweenMax.to(container, 0.5, {delay: 0.3, autoAlpha: 0, onComplete: () => {
      TweenMax.to('.game-form-success', 0.5, {delay: 1, autoAlpha: 1})
      window.scrollTo(0, 0);
    }})
  }

  function _initForm(lang) {
    translateForm(lang);

    // Check changes on form input
    BunnyValidation.Validation.initInline(form);
    // Check radio button, not handled by bunnyjs
    // initRadioButtons(form.elements.rules);
    // initRadioButtons(form.elements.newsletter_shop);
    // initRadioButtons(form.elements.newsletter_jpg);

    if (_bForm2) {
      form.querySelector('.form-group-newsletter_shop').style.display = 'none';
      form.querySelector('.form-group-newsletter_jpg').style.display = 'none';
    }

    if (window._sfPOS)
      form.querySelector('.form-group-newsletter_shop').style.display = 'none';

    form.addEventListener('submit', e => {
      e.preventDefault();
      // console.log('SUBMIT FORM');
      const submitBtns = form.querySelectorAll('[type="submit"]');
      [].forEach.call(submitBtns, submitBtn => {
        submitBtn.disabled = true;
      });

      // Check if form is valid then fill the database
      BunnyValidation.Validation.validateSection(form).then(result => {
        [].forEach.call(submitBtns, submitBtn => {
          submitBtn.disabled = false;
        });
        if (result === true) {
          const bRules = form.elements.rules.checked;
          // const bMode = getIsRadioButtonSelected(form.elements.mode);
          if(!bRules) {
            BunnyValidation.ValidationUI.setErrorMessage(document.getElementsByClassName('form-group-rules')[0], '!');
          }
          // if(!bMode) {
          //   console.log('Mode is not selected');
          //   BunnyValidation.ValidationUI.setErrorMessage(document.getElementsByClassName('form-group-mode')[0], '!');
          // }
          if(!bRules /* || !bMode */) {
            return;
          }
          console.log('>>> FORM IS VALID');
          console.log(form.elements);
          status.innerHTML = lang.status_pending;

          if (window._sfPOS) {
            var params = {};
            params.callback = function (response) {
              console.log('Response', response);
              if (response.success) {
                //SUCCESS
                status.innerHTML = lang.status_success;
                showFormSuccessMessage();
              }else{
                //ERROR
                console.log(response.message);
                status.innerHTML = lang.status_error;
                status.innerHTML += '<br />' + response.message;
            }};

            var data = {}; //DATA SCHEMA DEFINED ON 'GIGYA GOVERNANCE :: SCHEMA DEFINITION' SECTION
            var profile = {};   //DEFAULT PROFILE STRUCTURE
            var subscriptions = {}; //DEFAULT INTERESTS STRUCTURE
            subscriptions.subscriptionInterestFragrance = {};
            subscriptions.subscriptionInterestFragrance.email = {};
            subscriptions.subscriptionInterestFragrance.email.isSubscribed = true;
            profile.gender = form.elements.civil.value;
            profile.firstName = form.elements.firstname.value;
            profile.lastName = form.elements.lastname.value;
            profile.email = form.elements.email.value;
            profile.country = form.elements.country.value;
            // profile.languages = window.lang.split('-')[1];
            data.terms = form.elements.rules.checked;
            data.subscribe = form.elements.newsletter_jpg.checked || false;
            var user = {
              data: data,
              profile: profile,
              subscriptions: subscriptions
            }
            var params_data = {
              user: user,
              brand: 'JPG'
            }
            params.data = params_data; /* Method to be called on form submit */
            if (typeof ciam != 'undefined') {
              ciam.subscribe(params);
            } else {
              console.log('ciam is undefined');
            }
          } else {
            // console.log(`SUBMISSION !!!!!!!!!!!!!`);
            axios.post('https://brewsterdev.fr/jpg-lemale/submission.php', {
              gender: form.elements.civil.value,
              firstname: form.elements.firstname.value,
              lastname: form.elements.lastname.value,
              email: form.elements.email.value,
              country: form.elements.country.value,
              city: form.elements.city.value,
              question: form.elements.question.value,
              score: _score,
              rules: form.elements.rules.checked,
              nl_shop: form.elements.newsletter_shop.checked || 0,
              nl_jpg: form.elements.newsletter_jpg.checked || 0,
              retailer: window.retail || '',
              lang: window.langISO
            })
            .then(function (response) {
              console.log(response);
              if (response.status === 200) {
                if (response.data === 'OK') {
                  _onFormRegisterCompleteCbk();
                  hideForm();
                } else {
                  status.innerHTML = lang.status_error;
                  status.innerHTML += '<br />' + response.data;
                }
              } else {
                status.innerHTML = lang.status_error;
                status.innerHTML += '<br />' + response.data;
              }
            })
            .catch(function (error) {
              console.log(error);
              status.innerHTML = lang.status_error;
            });
          }
        } else {
          console.log('!!! FORM HAS ERROR !!!');
          BunnyValidation.Validation.focusInput(result[0]);
          status.innerHTML = lang.status_fields_error;
        }
      });
    });
  }

  // Radio buttons
  function initRadioButtons(radio) {
    for (let k = 0 ; k < radio.length; k++) {
      radio[k].checked = false;
      radio[k].addEventListener('change', function() {
        console.log(`${this.name} = ${this.value}`);
      });
    }
  }

  // function radioButtonSelected(radio) {
  //   console.log(`Radio button value : ${radio.value}`);
  //   return radio.value !== '' && radio.value !== undefined;
  // }

  function getIsRadioButtonSelected (radioButtons) {
    for(var i = 0; i < radioButtons.length; i++) {
      var button = radioButtons[i];
      if(button.checked) {
        return true;
      }
    }
    return false;
  }

  function getRadioButtonValue (radioButtons) {
    for(var i = 0; i < radioButtons.length; i++) {
      var button = radioButtons[i];
      if(button.checked) {
        return button.value;
      }
    }
    return null;
  }


  // Because the bunnyjs library is es6 I need to transpile it to es5
  // This is the Validation dist file, but instead, use the link below to compile into src/bunnyjs/
  // babel ./node_modules/bunnyjs/src/Validation.js --out-file ./src/bunnyjs/Validation.js
  // https://stackoverflow.com/questions/34747693/how-do-i-get-babel-6-to-compile-to-es5-javascript
  //
  // Could also look there for a global transpile
  // https://stackoverflow.com/questions/39321384/how-should-i-transform-es6-node-modules-with-browserify-and-babelify
  //



  return {
    initForm,
    showForm,
    hideForm
  }
}

export {Register as default}
